(function (global) {
  "use strict";

  var FETCH_MS = 8000;
  var DRINKS_ENDPOINT = "https://hq.agrouphospitality.uk/api/menus/published/drinks";
  var PAGE_HEADING = "sunday lunch";
  var DEDICATED_CHANNELS = {
    sunday: {
      endpoint: "https://hq.agrouphospitality.uk/api/menus/published/sunday",
      pageHeading: "sunday lunch",
    },
    set_lunch: {
      endpoint: "https://hq.agrouphospitality.uk/api/menus/published/set-lunch",
      pageHeading: "weekly set lunch",
    },
    continental_breakfast: {
      endpoint: "https://hq.agrouphospitality.uk/api/menus/published/continental-breakfast",
      pageHeading: "continental breakfast",
    },
    desserts: {
      endpoint: "https://hq.agrouphospitality.uk/api/menus/published/desserts",
      pageHeading: "desserts",
    },
  };

  function text(value) {
    return String(value == null ? "" : value).trim();
  }

  function dishLine(name, price) {
    var trimmedName = text(name);
    var trimmedPrice = text(price);
    if (!trimmedPrice) return trimmedName;
    return trimmedName + " " + trimmedPrice;
  }

  function channelKey(root) {
    return (
      text(root && root.getAttribute("data-ahq-channel")) ||
      text(root && root.getAttribute("data-expected-template"))
    );
  }

  function dedicatedChannel(root) {
    return DEDICATED_CHANNELS[channelKey(root)] || null;
  }

  function usesStatusFallback(root) {
    return text(root.getAttribute("data-ahq-fallback")) === "status";
  }

  function usesCategoryPresentation(root) {
    return text(root.getAttribute("data-ahq-presentation")) === "categories";
  }

  function usesQuietFallback(root) {
    return text(root.getAttribute("data-ahq-fallback")) === "quiet";
  }

  function quietFail(root, kind) {
    var menuNode = root.querySelector("[data-ahq-menu]");
    var fallbackLink = root.querySelector(".menu-actions__food-fallback");
    var status = root.querySelector("[data-ahq-menu-status]");
    if (menuNode) {
      menuNode.hidden = true;
      menuNode.replaceChildren();
    }
    if (status) {
      status.hidden = true;
      status.textContent = "";
    }
    if (fallbackLink) fallbackLink.hidden = true;
    setHostReady(root, false);
    root.setAttribute("data-ahq-state", kind === "error" ? "error" : "empty");
  }

  function showsPublishedMeta(root) {
    return !!dedicatedChannel(root);
  }

  function hostSection(root) {
    return root.closest(".menu-hub__panel, .menu-actions, .service-intro");
  }

  function setHostReady(root, ready) {
    var section = hostSection(root);
    if (!section) return;
    if (section.classList.contains("menu-actions")) {
      section.classList.toggle("menu-actions--ahq-ready", ready);
    }
    if (section.classList.contains("service-intro")) {
      section.classList.toggle("service-intro--ahq-ready", ready);
    }
    if (section.classList.contains("menu-hub__panel")) {
      section.classList.toggle("menu-hub__panel--ahq-ready", ready);
    }
  }

  function isMenuPayload(payload) {
    return !!(
      payload &&
      typeof payload === "object" &&
      payload.menu &&
      typeof payload.menu === "object" &&
      Array.isArray(payload.menu.groups)
    );
  }

  function menuMatches(menu, root) {
    if (!menu || typeof menu !== "object" || !Array.isArray(menu.groups)) return false;
    var business = text(root && root.getAttribute("data-expected-business"));
    var template = text(root && root.getAttribute("data-expected-template"));
    if (business && text(menu.businessId) !== business) return false;
    if (template && text(menu.templateKey) !== template) return false;
    return true;
  }

  function formatServiceDate(value) {
    var raw = text(value);
    if (!raw) return "";
    var iso = raw.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (!iso) return "";
    var date = new Date(Date.UTC(Number(iso[1]), Number(iso[2]) - 1, Number(iso[3])));
    if (Number.isNaN(date.getTime())) return "";
    return new Intl.DateTimeFormat("en-GB", {
      day: "numeric",
      month: "long",
      timeZone: "UTC",
    }).format(date);
  }

  function displayTitle(title, pageHeading) {
    var published = text(title);
    if (!published) return "";
    var heading = text(pageHeading || PAGE_HEADING).toLowerCase();
    if (published.toLowerCase() === heading) return "";
    return published;
  }

  function headingFor(root) {
    var fromAttr = text(root.getAttribute("data-page-heading"));
    if (fromAttr) return fromAttr;
    var dedicated = dedicatedChannel(root);
    return dedicated ? dedicated.pageHeading : PAGE_HEADING;
  }

  function fallback(root) {
    var menuNode = root.querySelector("[data-ahq-menu]");
    var fallbackLink = root.querySelector(".menu-actions__food-fallback");
    var status = root.querySelector("[data-ahq-menu-status]");
    if (menuNode) {
      menuNode.hidden = true;
      menuNode.replaceChildren();
    }
    if (status) {
      status.hidden = true;
      status.textContent = "";
    }
    if (fallbackLink) fallbackLink.hidden = false;
    setHostReady(root, false);
    root.setAttribute("data-ahq-state", "fallback");
  }

  function setStatus(root, kind, message) {
    var status = root.querySelector("[data-ahq-menu-status]");
    var menuNode = root.querySelector("[data-ahq-menu]");
    var fallbackLink = root.querySelector(".menu-actions__food-fallback");
    if (!status) {
      if (kind !== "ready") fallback(root);
      return;
    }
    root.setAttribute("data-ahq-state", kind);
    if (menuNode) {
      menuNode.hidden = true;
      menuNode.replaceChildren();
    }
    if (fallbackLink) fallbackLink.hidden = true;
    setHostReady(root, false);
    status.hidden = false;
    status.textContent = text(message);
  }

  function showMenu(root) {
    var menuNode = root.querySelector("[data-ahq-menu]");
    var fallbackLink = root.querySelector(".menu-actions__food-fallback");
    var status = root.querySelector("[data-ahq-menu-status]");
    if (!menuNode || !menuNode.childNodes.length) {
      if (usesStatusFallback(root)) {
        setStatus(root, "empty", root.getAttribute("data-empty") || "");
      } else {
        fallback(root);
      }
      return;
    }
    if (fallbackLink) fallbackLink.hidden = true;
    if (status) {
      status.hidden = true;
      status.textContent = "";
    }
    menuNode.hidden = false;
    setHostReady(root, true);
    root.setAttribute("data-ahq-state", "ready");
  }

  function renderCategoryMenu(root, menu) {
    var menuNode = root.querySelector("[data-ahq-menu]");
    if (!menuNode) return false;
    if (!menuMatches(menu, root)) {
      fail(root, usesStatusFallback(root) ? "empty" : "fallback");
      return false;
    }

    var groups = Array.isArray(menu.groups) ? menu.groups : [];
    var fragment = document.createDocumentFragment();
    var rendered = 0;

    groups.forEach(function (group) {
      if (!group || !Array.isArray(group.dishes)) return;
      var dishes = group.dishes.filter(function (dish) {
        return dish && text(dish.name);
      });
      if (!dishes.length) return;

      var body = document.createDocumentFragment();
      var note = text(group.note);
      if (note) {
        var noteEl = document.createElement("p");
        noteEl.className = "ahq-wine__note";
        noteEl.textContent = note;
        body.appendChild(noteEl);
      }
      dishes.forEach(function (dish) {
        var line = document.createElement("p");
        line.className = "ahq-wine__entry";
        var nameEl = document.createElement("span");
        nameEl.className = "ahq-wine__name";
        nameEl.textContent = text(dish.name);
        line.appendChild(nameEl);
        var price = text(dish.price);
        if (price) {
          var priceEl = document.createElement("span");
          priceEl.className = "ahq-wine__price";
          priceEl.textContent = price;
          line.appendChild(priceEl);
        }
        body.appendChild(line);
      });

      var heading = text(group.heading);
      var section;
      if (heading) {
        section = document.createElement("details");
        section.className = "ahq-wine__category";
        var summary = document.createElement("summary");
        summary.className = "ahq-wine__summary";
        var title = document.createElement("span");
        title.className = "ahq-wine__title";
        title.textContent = heading;
        summary.appendChild(title);
        section.appendChild(summary);
        var panel = document.createElement("div");
        panel.className = "ahq-wine__panel";
        panel.appendChild(body);
        section.appendChild(panel);
      } else {
        section = document.createElement("section");
        section.className = "ahq-wine__category ahq-wine__category--untitled";
        section.appendChild(body);
      }
      fragment.appendChild(section);
      rendered += 1;
    });

    if (!rendered) {
      fail(root, "empty");
      return false;
    }

    var guestNotice = text(menu && menu.guestNotice);
    if (guestNotice) {
      var noticeEl = document.createElement("p");
      noticeEl.className = "ahq-menu__guest-notice";
      noticeEl.textContent = guestNotice;
      fragment.appendChild(noticeEl);
    }

    menuNode.replaceChildren(fragment);
    showMenu(root);
    return true;
  }

  function renderMenu(root, menu) {
    var menuNode = root.querySelector("[data-ahq-menu]");
    if (!menuNode) return false;
    if (usesCategoryPresentation(root)) return renderCategoryMenu(root, menu);
    if (!menuMatches(menu, root)) {
      if (usesQuietFallback(root)) {
        quietFail(root, "empty");
      } else if (usesStatusFallback(root)) {
        setStatus(root, "empty", root.getAttribute("data-empty") || "");
      } else {
        fallback(root);
      }
      return false;
    }

    var groups = Array.isArray(menu.groups) ? menu.groups : [];
    var fragment = document.createDocumentFragment();

    if (showsPublishedMeta(root)) {
      var title = displayTitle(menu.title, headingFor(root));
      if (title) {
        var titleEl = document.createElement("p");
        titleEl.className = "ahq-menu__published-title";
        titleEl.textContent = title;
        fragment.appendChild(titleEl);
      }
      var serviceDate = formatServiceDate(menu.serviceDate);
      if (serviceDate) {
        var dateEl = document.createElement("p");
        dateEl.className = "ahq-menu__service-date";
        dateEl.textContent = serviceDate;
        fragment.appendChild(dateEl);
      }
    }

    groups.forEach(function (group) {
      if (!group || !Array.isArray(group.dishes) || group.dishes.length === 0) return;
      var section = document.createElement("section");
      section.className = "ahq-menu__group";
      var heading = text(group.heading);
      if (heading) {
        var headingEl = document.createElement("h3");
        headingEl.className = "ahq-menu__heading";
        headingEl.textContent = heading;
        section.appendChild(headingEl);
      }
      group.dishes.forEach(function (dish) {
        if (!dish || !text(dish.name)) return;
        var line = document.createElement("p");
        line.className = "ahq-menu__dish";
        var nameEl = document.createElement("span");
        nameEl.className = "ahq-menu__name";
        nameEl.textContent = text(dish.name);
        line.appendChild(nameEl);
        var price = text(dish.price);
        if (price) {
          line.appendChild(document.createTextNode(" "));
          var priceEl = document.createElement("span");
          priceEl.className = "ahq-menu__price";
          priceEl.textContent = price;
          line.appendChild(priceEl);
        }
        section.appendChild(line);
      });
      if (section.querySelector(".ahq-menu__dish")) fragment.appendChild(section);
    });

    if (!fragment.querySelector(".ahq-menu__dish")) {
      if (usesQuietFallback(root)) {
        quietFail(root, "empty");
      } else if (usesStatusFallback(root)) {
        setStatus(root, "empty", root.getAttribute("data-empty") || "");
      } else {
        fallback(root);
      }
      return false;
    }

    var guestNotice =
      menu && typeof menu.guestNotice === "string" ? text(menu.guestNotice) : "";
    if (guestNotice) {
      var noticeEl = document.createElement("p");
      noticeEl.className = "ahq-menu__guest-notice";
      noticeEl.textContent = guestNotice;
      fragment.appendChild(noticeEl);
    }

    menuNode.replaceChildren(fragment);
    showMenu(root);
    return true;
  }

  function fail(root, kind) {
    if (usesQuietFallback(root)) {
      quietFail(root, kind);
      return;
    }
    if (usesStatusFallback(root)) {
      var message =
        kind === "empty"
          ? root.getAttribute("data-empty") || ""
          : root.getAttribute("data-error") || "";
      setStatus(root, kind, message);
      return;
    }
    fallback(root);
  }

  function loadPublishedMenu(root) {
    var endpoint = text(root.getAttribute("data-endpoint"));
    if (usesCategoryPresentation(root)) {
      var template = text(root.getAttribute("data-expected-template"));
      if (endpoint !== DRINKS_ENDPOINT || template !== "drinks") {
        fail(root, "error");
        return Promise.resolve();
      }
    }
    var dedicated = dedicatedChannel(root);
    if (dedicated && endpoint !== dedicated.endpoint) {
      fail(root, "error");
      return Promise.resolve();
    }
    if (!endpoint) {
      fail(root, "error");
      return Promise.resolve();
    }

    if (usesStatusFallback(root)) {
      setStatus(root, "loading", root.getAttribute("data-loading") || "");
    }

    var controller = new AbortController();
    var timer = global.setTimeout(function () {
      controller.abort();
    }, FETCH_MS);

    return fetch(endpoint, {
      method: "GET",
      credentials: "omit",
      signal: controller.signal,
      cache: "no-store",
    })
      .then(function (response) {
        if (response.status === 404) {
          fail(root, "empty");
          return null;
        }
        if (!response.ok) {
          fail(root, "error");
          return null;
        }
        return response.json().catch(function () {
          return null;
        });
      })
      .then(function (payload) {
        if (payload == null) return;
        if (!isMenuPayload(payload) || !menuMatches(payload.menu, root)) {
          fail(root, usesStatusFallback(root) ? "empty" : "fallback");
          return;
        }
        renderMenu(root, payload.menu);
      })
      .catch(function () {
        fail(root, "error");
      })
      .then(function () {
        global.clearTimeout(timer);
      });
  }

  function bind(root) {
    if (root.getAttribute("data-ahq-bound") === "true") return;
    if (text(root.getAttribute("data-preview-mode"))) return;
    root.setAttribute("data-ahq-bound", "true");
    loadPublishedMenu(root);
  }

  function start() {
    document.querySelectorAll("[data-ahq-published-menu]").forEach(bind);
  }

  global.AhqPublishedMenu = {
    dishLine: dishLine,
    renderMenu: renderMenu,
    fallback: fallback,
    setStatus: setStatus,
    loadPublishedMenu: loadPublishedMenu,
    isMenuPayload: isMenuPayload,
    menuMatches: menuMatches,
    formatServiceDate: formatServiceDate,
    displayTitle: displayTitle,
    SUNDAY_ENDPOINT: DEDICATED_CHANNELS.sunday.endpoint,
    SET_LUNCH_ENDPOINT: DEDICATED_CHANNELS.set_lunch.endpoint,
    CONTINENTAL_BREAKFAST_ENDPOINT: DEDICATED_CHANNELS.continental_breakfast.endpoint,
    DESSERTS_ENDPOINT: DEDICATED_CHANNELS.desserts.endpoint,
    DRINKS_ENDPOINT: DRINKS_ENDPOINT,
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})(typeof window !== "undefined" ? window : globalThis);
